import svgUrl from "ni:svgr;1VmYXDG8VYbG1dTufvatFk9ePw4Z_nnGsT058BqQrYQ";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const LocalFileMIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}><path fill="var(--tbl--colors--icons--transformation--primary)" fillOpacity={0.4} fillRule="evenodd" d="M7 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8l-5-6H7Z" clipRule="evenodd" /><path fill="#fff" fillOpacity={0.5} d="m20 8-5-6v4a2 2 0 0 0 2 2h3Z" /></svg>;
const Memo = memo(LocalFileMIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "LocalFileMIcon";
}